import { FormAction, FormState, SetAutoStartLinkAction, SetResetFormAction } from "./types";

import INITIAL_QUESTIONS from '../../data/questions';
import { FormDataTypes } from "./actions";
import { CgiProvider } from "../../interfaces/CGI";

export const initialFormState: FormState = {
    activeScene: 'START',
    answersToQuestions: [],
    formViewState: {
        questionnaire: JSON.parse(JSON.stringify(INITIAL_QUESTIONS)),
        previousQuestionnaires: [],
        currentStep: 1,
    },
    debug: false,
    contactInfo: {
        firstName: '',
        familyName: '',
        personalIdentityNumber: '',
        street: '',
        postalCode: '',
        city: '',
        country: '',
        email: '',
        phoneNumber: '',
        memberCode: ''
    },
    typeOfNewMember: 'manually',
    authenticationType: 'same-device',
    provider: CgiProvider.BankId,
    paymentInformation: null,
    autoStartLink: undefined,
    orderRef: undefined,
    qrStartToken: undefined,
    requestStartedMilliseconds: undefined,
    userAge: null,
    union: undefined,
    formMode: 'loading',
    enableMemberCodeField: false,
    umbracoPageId: undefined
};

export function formReducer(state: FormState, action: FormAction): FormState {
    switch (action.type) {
        case FormDataTypes.SetFormSceneAction:
            return {
                ...state,
                activeScene: action.payload.scene
            }
        case FormDataTypes.SetAutoStartLinkAction:
            return {
                ...state,
                autoStartLink: action.payload.autoStartLink
            }
        case FormDataTypes.SetResetFormAction:
            return {
                ...initialFormState,
                formViewState: {
                    ...initialFormState.formViewState,
                    questionnaire: JSON.parse(JSON.stringify(INITIAL_QUESTIONS))
                },
                debug: state.debug,
                formMode: state.formMode,
                ...(action.payload ? action.payload : {}) // Do not change debug state
            }
        case FormDataTypes.SetDebugAction:
            return {
                ...state,
                debug: action.payload.debug
            }
        case FormDataTypes.SetContactInformationAction:
            return {
                ...state,
                contactInfo: action.payload.info
            }
        case FormDataTypes.SetAnswersToQuestionsAction:
            return {
                ...state,
                answersToQuestions: action.payload.answers
            }
        case FormDataTypes.SetGivenConsentAction:
            return {
                ...state,
                givenConsent: action.payload.consent
            }
        // case FormDataTypes.SetQuestionnaireAction:
        //     const clone = JSON.parse(JSON.stringify(action.payload.questionnaire));
        //     return {
        //         ...state,
        //         questionnaire: clone
        //     }
        case FormDataTypes.SetPaymentInformation:
            return {
                ...state,
                paymentInformation: action.payload.paymentChoice
            }
        case FormDataTypes.SetFormViewState:
            return {
                ...state,
                formViewState: {
                    ...state.formViewState,
                    ...action.payload
                }
            }
        case FormDataTypes.SetUnionState:
            return {
                ...state,
                union: action.payload.union
            }
        case FormDataTypes.SetTypeOfMemberState:
            return {
                ...state,
                typeOfNewMember: action.payload.typeOfMember
            }
        case FormDataTypes.SetUserAgeAction:
            return {
                ...state,
                userAge: action.payload.userAge
            }
        case FormDataTypes.SetRequestStartedMillisecondsAction:
            return {
                ...state,
                requestStartedMilliseconds: action.payload.requestStartedMilliseconds
            }
        case FormDataTypes.SetOrderRefAction:
            return {
                ...state,
                orderRef: action.payload.orderRef
            }
        case FormDataTypes.SetQrStartTokenAction:
            return {
                ...state,
                qrStartToken: action.payload.qrStartToken
            }
        case FormDataTypes.SetAuthenticationType:
            return {
                ...state,
                authenticationType: action.payload.authenticationType
            }
        case FormDataTypes.SetCgiProvider:
            return {
                ...state,
                provider: action.payload.provider
            }
        case FormDataTypes.SetFormMode:
            return {
                ...state,
                formMode: action.payload.mode
            }
        case FormDataTypes.SetEnableMemberCodeField:
            return {
                ...state,
                enableMemberCodeField: action.payload.enableMemberCodeField
            }
        case FormDataTypes.SetUmbracoPageId:
            return {
                ...state,
                umbracoPageId: action.payload.id
            }
        default:
            return state;
    }
}